import {
    getInstagramAccounts,
    getTiktokAccounts,
    deleteTiktokAccount,
    deleteInstagramAccount,
    getInstagramStatistic,
    getTiktokStatistic,
    getInstagramAccountByQuery,
    getTiktokAccountByQuery,
    storeTiktokAccount,
    getInstagramPosts,
    getTiktokPosts,
    getInstagramAccount,
    getTiktokAccount,
} from "@/api/accounts";
import Vue from 'vue';
import {showSuccess} from '../../utils/notifications'

const defaultAccountsData = {
    data: [],
    current_page: 1,
    last_page: 1
};

const state = {
    accounts: defaultAccountsData,
    accountData: null,
    posts: [],
    statistic: {
        likes: 0,
        comments: 0,
        followers: 0,
        views: 0,
    }
};

const getters = {
    accounts: state => {
        return state.accounts;
    },

    accountData: state => {
        return state.accountData;
    },

    posts: state => {
        return state.posts;
    },

    statistic: state => {
        return state.statistic;
    }
};

const mutations = {
    accountListReceivedSuccess: (state, response) => {
        state.accounts.data.push(...response.data);
        state.accounts.current_page = response.meta.current_page;
        state.accounts.last_page = response.meta.last_page;
    },

    accountDataReceivedSuccess: (state, response) => {
        state.accountData = response;
        state.accountData.end_cursor = '';
    },

    updateAccountDataEndCursor: (state, cursor) => {
        state.accountData.end_cursor = cursor
    },

    postsReceivedSuccess: (state, response) => {
        state.posts.push(...response);
    },

    clearPosts: (state) => {
        state.posts = [];
    },

    statisticReceivedSuccess: (state, response) => {
        Vue.set(state.statistic, 'comments', parseInt(response.commentsCount));
        Vue.set(state.statistic, 'likes', parseInt(response.likesCount));
        Vue.set(state.statistic, 'followers', parseInt(response.followersCount));
        Vue.set(state.statistic, 'views', parseInt(response.viewsCount));
        console.log(state.statistic);
    },

    clearAccounts: state => {
        state.accounts = {data: [], current_page: 1, last_page: 1};
        state.statistic = {
            likes: 0,
            comments: 0,
            followers: 0,
            views: 0,
        };
    },

    deleteAccount: (state, data) => {
        state.accounts.data.splice(data.index, 1);
    },

    accountAdded: (state, data) => {
        state.accounts.data.unshift(data);
    },
};

const actions = {
    loadAccounts({commit}, data) {
        return new Promise((resolve, reject) => {
            let api = getInstagramAccounts;
            if (data.type !== "instagram") {
                api = getTiktokAccounts;
            }

            api(data.page)
                .then(response => {
                    commit("accountListReceivedSuccess", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    loadAccountInstagram({commit}, id) {
        return new Promise((resolve, reject) => {
            var element = document.getElementById("postLoader");
            element.classList.add("active");
            getInstagramAccount(id)
                .then((response) => {
                    commit("accountDataReceivedSuccess", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    loadAccountTiktok({commit}, id) {
        return new Promise((resolve, reject) => {
            var element = document.getElementById("postLoader");
            element.classList.add("active");
            getTiktokAccount(id)
                .then((response) => {
                    commit("accountDataReceivedSuccess", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    loadPostsInstagram({commit, state}) {
        const endCursor = state.accountData.end_cursor === null ? '' : state.accountData.end_cursor;
        const query = '{"id":"' + state.accountData.social_id + '","account":"' + state.accountData.account + '","first":12,"after":"' + endCursor + '"}';
        return new Promise((resolve, reject) => {
            getInstagramPosts(query)
                .then((response) => {
                    var showAlert = document.getElementById("showAlert");
                    if (response['posts'] === undefined || response['posts'].length == 0) {
                        showAlert.classList.remove("d-none");
                    } else {
                        showAlert.classList.add("d-none");
                    }
                    if (Array.isArray(response['posts'])) {
                        commit("postsReceivedSuccess", response['posts']);
                        if (response['end_cursor'] && response['end_cursor'] !== 'nullTake') {
                            const endCursor = response['end_cursor'];
                            commit("updateAccountDataEndCursor", endCursor);
                        }
                    }
                    var element = document.getElementById("postLoader");
                    element.classList.remove("active");
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    loadPostsTiktok({commit, state}) {
        const endCursor = state.accountData.end_cursor ? state.accountData.end_cursor : '0';
        const query = (state.accountData.social_id ? state.accountData.social_id : state.accountData.account) + '/' + endCursor;

        return new Promise((resolve, reject) => {
            getTiktokPosts(query)
                .then((response) => {
                    const endCursor = response['end_cursor'];
                    commit("updateAccountDataEndCursor", endCursor);
                    response['social_id'] = state.accountData.social_id;
                    var element = document.getElementById("postLoader");
                    element.classList.remove("active");
                    console.log(response);
                    if (response['posts']) {
                        commit("postsReceivedSuccess", response.posts);
                        resolve(response);
                    } else {
                        reject('empty');
                    }

                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    clearPosts({commit}) {
        commit("clearPosts");
    },

    clearAccountsData({commit}) {
        commit("clearAccounts");
    },

    deleteAccount({commit, state}, data) {
        const id = state.accounts.data[data.index].id;
        let api = deleteInstagramAccount;
        if (data.type != "instagram") {
            api = deleteTiktokAccount;
        }

        api(id).then(() => {
            commit("deleteAccount", data);
        });
    },

    async loadStatistic({commit}, type) {
        let api = getInstagramStatistic;
        if (type !== "instagram") {
            api = getTiktokStatistic;
        }

        await api().then(response => {
            console.log(response);
            commit("statisticReceivedSuccess", response);

        });
    },

    findInstagramAccount(_, query) {
        return getInstagramAccountByQuery(query);
    },

    async addInstagramAccount({commit}, data) {
        showSuccess("Added successfully");
        commit("accountAdded", data);
    },

    findTiktokAccount(_, query) {
        return getTiktokAccountByQuery(query);
    },

    addTiktokAccount({commit}, data) {
        return storeTiktokAccount(data).then(response => {
            commit("accountAdded", response);
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
